<template>
    <v-form ref="step_1">
        <div class="row">
            <div class="form-inline col-md-3">
                <Tooltip text="Activation name."></Tooltip>
                <i class="fas fa-cog" ></i> <span style="padding-left: 5px;"> General</span>
            </div>
            <div class="form-group col-md-4">
                <v-text-field
                    v-model="description"
                    label="Description"
                    :rules="[requiredDescription]"
                ></v-text-field>
            </div><!--form-group-->
        </div>

        <div>
            <div class="row" v-for="dataItemSet in $store.getters['ActivateAudienceStore/getActivation'].dataset">
                <div class="form-inline col-md-3">
                    <Tooltip text="Date period for the custom audience."></Tooltip>
                    <i class="fas fa-calendar-alt" ></i> <span style="padding-left: 5px;">{{ dataItemSet.analysistype }} Analysis Recency</span>
                </div>
                <div class="form-group col-md-2">
                    <v-text-field
                        v-model="dataItemSet.startDate"
                        label="Start Date"
                        disabled
                    ></v-text-field>
                </div><!--form-group-->
                <span class="pt-10 mx-2">TO</span>
                <div class="form-group col-md-2">
                    <v-text-field
                        v-model="dataItemSet.endDate"
                        label="End Date"
                        disabled
                    ></v-text-field>
                </div><!--form-group-->
            </div>
        </div>

        <div class="row" v-if="!$store.getters['ActivateAudienceStore/getLimitByFrequencyStatus'] && !$store.getters['ActivateAudienceStore/getLimitByDistanceStatus'] && !$store.getters['ActivateAudienceStore/getActivationAnalyses'].includes('anonymized')">
            <div class="form-inline col-md-3">
                <Tooltip text="Enter the limit of devices to be exported."></Tooltip>
                <i class="fas fa-tachometer-alt" ></i> <span style="padding-left: 5px;"> Limit</span>
            </div>
            <div class="form-group col-md-4">
                <v-text-field
                    v-model="audience"
                    label='Limit Audience'
                    type="number"
                    min="0"
                    :max="$store.getters['ActivateAudienceStore/getActivation'].resultsCount"
                    :rules="[requiredAudience]"
                ></v-text-field>
                <small>Maximum {{ new Intl.NumberFormat().format($store.getters['ActivateAudienceStore/getActivation'].resultsCount) }} devices.</small>
            </div><!--form-group-->
        </div>

        <div class="row" v-if="(
            ($store.getters['ActivateAudienceStore/getActivation'].analyses &&
            $store.getters['ActivateAudienceStore/getActivation'].analyses.distance &&
            $store.getters['ActivateAudienceStore/getActivation'].analyses.distance.process) &&
            $store.getters['ActivateAudienceStore/getActivation'].distanceResults.length) &&
            !$store.getters['ActivateAudienceStore/getLimitByFrequencyStatus']
        ">
            <div class="form-inline col-md-3">
                <Tooltip text="Select this option if you want to limit <br> the export devices based on Distance Analysis."></Tooltip>
                <i class="fas fa-ruler-horizontal" ></i> <span style="padding-left: 5px;"> Limit by Distance</span>
            </div>
            <div class="form-group col-md-4">
                <v-switch
                    class="pt-5"
                    v-model="distance_limit_status"
                    inset
                ></v-switch>
            </div><!--form-group-->
        </div>

        <div class="row" v-if="distance_limit_status">
            <div class="form-inline col-md-3">
                <Tooltip text="To limit the exported devices by distance <br> adjust the max distance in meters."></Tooltip>
                <i class="fas fa-ruler-horizontal"></i> <span style="padding-left: 5px;"> Distance (meters)</span>
            </div>
            <div class="form-group col-md-4">
                <template>
                    <v-slider
                        v-model="distance_limit"
                        :max="$store.getters['ActivateAudienceStore/getRangeMaximum']('distance')"
                        :min="$store.getters['ActivateAudienceStore/getRangeMinimum']('distance')"
                        step="25"
                        hide-details
                        thumb-label="always"
                    >
                    </v-slider>
                </template>
            </div><!--form-group-->
        </div>

        <div class="row" v-if="(
            ($store.getters['ActivateAudienceStore/getActivation'].analyses &&
            $store.getters['ActivateAudienceStore/getActivation'].analyses.frequency.process) &&
            $store.getters['ActivateAudienceStore/getActivation'].freqResults.length) &&
            !$store.getters['ActivateAudienceStore/getLimitByDistanceStatus']
        ">
            <div class="form-inline col-md-3">
                <Tooltip text="Select this option if you want to limit <br> the export devices based on Frequency Analysis."></Tooltip>
                <i class="fas fa-tachometer-alt" ></i> <span style="padding-left: 5px;"> Limit by Frequency</span>
            </div>
            <div class="form-group col-md-4">
                <v-switch
                    class="pt-5"
                    v-model="frequency_limit_status"
                    inset
                ></v-switch>
            </div><!--form-group-->
        </div>

        <div class="row" v-if="frequency_limit_status && !$store.getters['ActivateAudienceStore/getActivation'].analyses.frequency.day_part">
            <div class="form-inline col-md-3">
                <Tooltip text="To limit the exported devices by frequency <br> adjust the frequency min/max range."></Tooltip>
                <i class="fa fa-street-view"></i> <span style="padding-left: 5px;"> Freq. Range</span>
            </div>
            <div class="form-group col-md-6">
                <v-range-slider
                    v-model="frequency_range"
                    :max="$store.getters['ActivateAudienceStore/getRangeMaximum']('freq')"
                    :min="$store.getters['ActivateAudienceStore/getRangeMinimum']('freq')"
                    hide-details
                    class="align-center"
                >
                    <template v-slot:prepend>
                        <span class="pt-3 mr-2">Min:</span>
                        <v-text-field
                            :value="$store.getters['ActivateAudienceStore/getFrequencyRange'][0]"
                            class="mt-0 pt-0 custom-input"
                            hide-details
                            single-line
                            type="number"
                            :min="$store.getters['ActivateAudienceStore/getRangeMinimum']('freq')"
                            :max="$store.getters['ActivateAudienceStore/getRangeMaximum']('freq')"
                            style="width: 60px"
                            @change="limitRangeChanged(0, $event)"
                        ></v-text-field>
                    </template>
                    <template v-slot:append>
                        <span class="pt-3 mr-2">Max:</span>
                        <v-text-field
                            :value="$store.getters['ActivateAudienceStore/getFrequencyRange'][1]"
                            class="mt-0 pt-0 custom-input"
                            hide-details
                            single-line
                            type="number"
                            :min="$store.getters['ActivateAudienceStore/getRangeMinimum']('freq')"
                            :max="$store.getters['ActivateAudienceStore/getRangeMaximum']('freq')"
                            style="width: 60px"
                            @change="limitRangeChanged(1, $event)"
                        ></v-text-field>
                    </template>
                </v-range-slider>
            </div><!--form-group-->
        </div>

        <div class="row" v-if="frequency_limit_status && $store.getters['ActivateAudienceStore/getActivation'].analyses.frequency.day_part">
            <div class="form-inline col-md-3">
                <Tooltip text="To generate a frequency report by day part, select the beginning and ending hours. <br> Hours are adjusted according to the locations' time zone."></Tooltip>
                <i class="fa fa-street-view"></i> <span style="padding-left: 5px;"> Freq. Range</span>
            </div>
            <div class="form-group col-md-2">
                <v-select
                    label="Start Hour"
                    v-model="$store.getters['ActivateAudienceStore/getFrequencyRange'][0]"
                    :items="this.day_hours"
                    @change="limitRangeChanged(0, $event)"
                ></v-select>
            </div><!--form-group-->
            <div class="form-group col-md-2">
                <v-select
                    label="End Hour"
                    v-model="$store.getters['ActivateAudienceStore/getFrequencyRange'][1]"
                    :items="this.day_hours"
                    @change="limitRangeChanged(1, $event)"
                ></v-select>
            </div><!--form-group-->
        </div>

        <div class="row" v-if="frequency_limit_status || distance_limit_status">
            <div class="form-inline col-md-3">
                <Tooltip text="Devices Limit"></Tooltip>
                <i class="fas fa-tachometer-alt"></i>
                <span v-if="$store.getters['ActivateAudienceStore/getActivation'].analyses.frequency.day_part" style="padding-left: 5px;"> Hourly Unique Visits</span>
                <span v-else style="padding-left: 5px;"> Limit Audience</span>
            </div>
            <div class="form-group col-md-4">
                <h5 class="pt-2">{{ new Intl.NumberFormat().format(this.$store.getters['ActivateAudienceStore/getLimitsTotal']) }} </h5>
            </div><!--form-group-->
        </div>

        <div class="row">
            <div class="form-inline col-md-3">
                <Tooltip text="Receive email upon completion."></Tooltip>
                <i class="fas fa-envelope-open-text"></i> <span style="padding-left: 5px;">Notification</span>
            </div>

            <div class="form-group col-md-4 push-down-36">
                <v-switch
                    v-model="notification"
                    inset
                ></v-switch>
            </div><!--form-group-->
        </div>
    </v-form>
</template>

<script>

import Tooltip from "../../../../../shared/components/Tooltip.vue";
import validation_rules from "../../../../mixin/validation_rules";

export default {
    name: "ActivationLimits",
    components: {Tooltip},
    props: [],
    mixins: [validation_rules],
    data: () => ({
        step: 1,
    }),
    methods: {
        limitRangeChanged(index, event) {
            this.$store.commit('ActivateAudienceStore/SET_FREQUENCY_LIMIT_RANGE_BY_INDEX', {
                index: index,
                value: parseInt(event)
            })
            this.$store.commit('ActivateAudienceStore/CALCULATE_TOTAL_VISITS')
        },
        validateForm() {
            let current_step = this.$store.getters['ActivateAudienceStore/getCurrentStep']
            if (this.$refs['step_' + current_step].validate()) {
                this.$store.dispatch('ActivateAudienceStore/increaseProcessStep')
            }
        },
        rangeSelectionChanged(event) {
            this.$store.commit('ActivateAudienceStore/SET_FREQUENCY_LIMIT_RANGE', event)
            this.$store.commit('ActivateAudienceStore/CALCULATE_TOTAL_VISITS')
        }
    },
    created() {
        //
    },
    mounted() {
        //
    },
    computed: {
        audience: {
            get() {
                return this.$store.getters['ActivateAudienceStore/getAudience']
            },
            set(value) {
                this.$store.commit('ActivateAudienceStore/SET_AUDIENCE', value)
            }
        },
        description: {
            get() {
                return this.$store.getters['ActivateAudienceStore/getDescription']
            },
            set(value) {
                this.$store.commit('ActivateAudienceStore/SET_DESCRIPTION', value)
            }
        },
        distance_limit_status: {
            get() {
                return this.$store.getters['ActivateAudienceStore/getLimitByDistanceStatus']
            },
            set(value) {
                this.$store.commit('ActivateAudienceStore/SET_DISTANCE_LIMIT_STATUS', value)
                if (value) {
                    this.$store.commit('ActivateAudienceStore/CALCULATE_TOTAL_VISITS_BY_DISTANCE')
                }
            }
        },
        distance_limit: {
            get() {
                return this.$store.getters['ActivateAudienceStore/getDistanceAnalysesLimit']
            },
            set(value) {
                this.$store.commit('ActivateAudienceStore/SET_DISTANCE_LIMIT', value)
                this.$store.commit('ActivateAudienceStore/CALCULATE_TOTAL_VISITS_BY_DISTANCE')
            }
        },
        frequency_limit_status: {
            get() {
                return this.$store.getters['ActivateAudienceStore/getLimitByFrequencyStatus']
            },
            set(value) {
                this.$store.commit('ActivateAudienceStore/SET_FREQUENCY_LIMIT_STATUS', value)
                if (value) {
                    this.$store.commit('ActivateAudienceStore/CALCULATE_TOTAL_VISITS')
                }
            }
        },
        frequency_range: {
            get() {
                return this.$store.getters['ActivateAudienceStore/getFrequencyRange']
            },
            set(value) {
                this.$store.commit('ActivateAudienceStore/SET_FREQUENCY_LIMIT_RANGE', value)
                this.$store.commit('ActivateAudienceStore/CALCULATE_TOTAL_VISITS')
            }
        },
        notification: {
            get() {
                return this.$store.getters['ActivateAudienceStore/getNotificationPreference']
            },
            set(value) {
                this.$store.commit('ActivateAudienceStore/SET_NOTIFICATION_PREFERENCE', value)
            }
        },
    },
    watch: {
        //
    }
}
</script>

<style scoped>

</style>